let inform = {
    title: "Notification",
    state: {
        title: "State",
        placeholder: "Please select a status",
        value0: "ALL",
        value1: "Unread",
        value2: "Read",
    },
    filtersTitle: "Notification title",
    titlePlaceholder: "Please enter a title",
    filtersContent: "Notification content",
    contentPlaceholder: "Please enter content",
    columns: {
        title: "Notification title",
        publishTime: "Delivery time",
        stateStr: "State",
        content: "Notification content",
        managerName: "Sender",
    },
    read: "Read",
    warn: "Please select a notification to read",
    confirm: "Are you sure you want to mark as read?",
    details: {
        title: "Message details",
        list01: "Notification title",
        list02: "Delivery time",
        list03: "Elapsed time",
        list04: "State",
        list05: "Notification content",
        list06: "Sender",
    }
}

export default inform